import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  Filler
);

const Graph = ({graphData1, keyName}) => {
  // const graphData = {
  //   labels: ["08-02-1993", "08-02-1993", "08-02-1993", "08-02-1993", "08-02-1993"],
  //   datasets: [
  //     {
  //       label: "Revenue",
  //       data: [3000, 200, 10, 400, 8000, 6000],
  //       borderColor: "red",
  //       backgroundColor: "rgba(192, 192, 42, 0.2)", // Light yellow fill
  //       borderWidth: 1,
  //       fill: true,
  //       pointRadius: 1, // Set the point radius here
  //     },
  //     {
  //       label: "Media Cost",
  //       data: [2002, 3300, 3400, 2200, 7000, 8000],
  //       borderColor: "green",
  //       backgroundColor: "rgba(109, 220, 127, 0.25)", // Light green fill
  //       borderWidth: 1,
  //       fill: true,
  //       pointRadius: 1, // Set the point radius here
  //     },
  //     {
  //       label: "Margin",
  //       data: [7700, 4000, 1100, 5000, 1000, 8000],
  //       borderColor: "blue",s
  //       backgroundColor: "rgba(119, 122, 253, 0.25)", // Light blue fill
  //       borderWidth: 1,
  //       fill: true,
  //       pointRadius: 1, // Set the point radius here
  //     },
  //   ],
  // };
console.log(graphData1, "graphData1graphData1**")

  const graphData = {
    labels: graphData1[keyName]?.date,
    datasets: [
      {
        label: "Advertiser Cost",
        data: graphData1[keyName]?.advertiser_cost,
        borderColor: "red",
        backgroundColor: "rgba(192, 192, 42, 0.2)", // Light yellow fill
        borderWidth: 1,
        fill: true,
        pointRadius: 1, // Set the point radius here
        cubicInterpolationMode: 'monotone',
      },
      {
        label: "Media Cost",
        data: graphData1[keyName]?.media_cost,
        borderColor: "green",
        backgroundColor: "rgba(109, 220, 127, 0.25)", // Light green fill
        borderWidth: 1,
        fill: true,
        pointRadius: 1, // Set the point radius here
        cubicInterpolationMode: 'monotone',
      },
      {
        label: "Savings",
        data: graphData1[keyName]?.savings,
        borderColor: "blue",
        backgroundColor: "rgba(119, 122, 253, 0.25)", // Light blue fill
        borderWidth: 1,
        fill: true,
        pointRadius: 1, // Set the point radius here
        cubicInterpolationMode: 'monotone',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false,
        position: 'top',
        labels: {
          font: {
            size: 10, // Font size for legend labels
          },
        },
      },
      title: {
        display: false,
        text: 'Custom Chart Title',
        font: {
          size: 5 // Adjust the title font size if needed
        }
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 8, // Font size for x-axis labels
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 8, // Font size for y-axis labels
          },
        },
      },
    },
  };

  

  return (
    <>
      <Line options={options} data={graphData} />
      {/* <Line options={options} data={graphData} /> */}
    </>
  );
};

export default Graph;